import { DatePipe, DecimalPipe, JsonPipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProductDetailModalComponent } from '../../product-detail-modal/product-detail-modal.component';
import { OrderDetailModel } from './models/OrderDetailModel';

@Component({
  selector: 'app-order-detail-box',
  standalone: true,
  imports: [JsonPipe, DatePipe, DecimalPipe],
  templateUrl: './order-detail-box.component.html',
  styleUrl: './order-detail-box.component.scss'
})
export class OrderDetailBoxComponent implements OnInit {

  unitsSum: number | undefined;

  @Input()
  orderDetails?: OrderDetailModel;

  @Input()
  orderNumber!: string;
  constructor(private modalService: NgbModal) { }

  ngOnInit(): void {
    if (this.orderDetails) {
      this.unitsSum = this.orderDetails.productDetails.products.reduce((acc: any, product: any) => {
        acc = acc + product.quantity;
        return acc;
      }, 0);
    }
  }

  openProductDetailModal() {
    const modalRef = this.modalService.open(ProductDetailModalComponent, { size: 'lg' });
    modalRef.componentInstance.orderNumber = this.orderNumber;
    modalRef.componentInstance.productDetails = this.orderDetails?.productDetails;
  }
}
